module.exports = __webpack_public_path__ + "h5/img/f0.6546fcfd.jpg";